module.exports = __webpack_public_path__ + "img/stegi-radio-logo.9e1eff9c.svg";